/* eslint-disable */

import React from 'react';
import ReactDOM from 'react-dom/client';
import {App} from './App';
import Store from './contexts/WordList';
import {ThemeProvider} from './contexts/Theme';
import './styles/app.css';
import * as serviceWorker from './serviceWorker';

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <Store>
        <App />
      </Store>
    </ThemeProvider>
  </React.StrictMode>
);

// Unregister any previously installed service worker so that iOS/Android
// always fetches fresh assets after a deployment instead of serving a
// stale cache indefinitely.
serviceWorker.unregister();
